import { useQuery } from "@tanstack/react-query";
import { fetchCollectionsByBudget } from "@/api/collections";

// The tier's composed product feed for the Collections tier-detail page. Collections-scoped twin of
// useCollectionsByBudget (which hits the campaign-builder route) — same feed, no CAMPAIGN_BUILDER dep.
export function useCollectionTierProducts(budget: number | null) {
  return useQuery({
    queryKey: ["collections", "by-budget", budget],
    queryFn: () => fetchCollectionsByBudget(budget!),
    // Unassigning a Custom Collection product must drop it from the tier page now, not after 5 min.
    staleTime: 0,
    enabled: budget !== null && !Number.isNaN(budget),
  });
}
